import React from 'react';

import css from './Toast.module.scss';
import { RewardBadge } from '../../../modularReduxComponents/Widgets/RewardBadge';

interface ToastProps {
  heading: string;
  message: string;
  rewardValue: number;
}

const Toast = ({ heading, message, rewardValue }: ToastProps) => {
  return (
    <div className={css.toastContainer}>
      <div className={css.toastTextContainer}>
        <p className={css.head}>{heading}</p>
        <p className={css.message}>{message}</p>
      </div>
      <div className={css.badge}>
        <RewardBadge head={'Get'} value={rewardValue} />
      </div>
    </div>
  );
};

export default Toast;
